import React, { useMemo } from "react";
import { Box, Typography  } from "@mui/material";
import { useScreenSize } from "../../../_context/ScreenSizeProvider";
import CircularTextComponent from "./CircularTextComponent";
import AnimatedAccordion from "../../../_base/Accordion";
import useSmoothResponsiveFontSize from "../../../../_hook/useSmoothResponsiveFontSize";

const FaqSection = () => {
  const { width } = useScreenSize();
  const customfontsize = useSmoothResponsiveFontSize();
  // Memoizing FAQs to avoid unnecessary re-renders
  const faqs = useMemo(
    () => [
      {
        question: "What does Musa Institute for Academic and Skills Development offer?",
        answer:
          "We offer a range of scientific education programs, including workshops, lectures, and mentorships designed to help you excel in your field.",
      },
      {
        question:
          "How can students benefit from Musa Institute for Academic and Skills Development?",
        answer:
          "Students gain hands-on experience and deep understanding through expert guidance and real-world applications.",
      },
      {
        question: "What training programs are available?",
        answer:
          "Our programs range from interactive workshops to personalized mentorship, covering various scientific fields and tailored to different career goals.",
      },
      {
        question: "Why choose Musa Institute for Academic and Skills Development?",
        answer:
          "Our commitment to excellence, innovative education, and supportive environment make us a leader in scientific education.",
      },
    ],
    []
  );

  return (
    <Box
      minHeight={`${width / 4}px`}
      display="flex"
      flexDirection={{ lg: "row", md: "column", sm: "column", xs: "column" }}
      justifyContent="center"
      alignItems="stretch"
    >
      <Box
        flex="1"
        p={2}
        sx={{
          display: { lg: "flex", md: "none", sm: "none", xs: "none" },
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <CircularTextComponent
          text="* EDUCATION * SYSTEM * CAN * MAKE * CHANGE "
          radius={width / 4 - (width / 4) * 0.2}
          imageUrl="./img/faqs.png"
        />
      </Box>

      <Box flex="1" py={2} textAlign="center">
        <Box sx={{ mb: 6, textAlign: "start" }}>
          <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 1 ,fontSize: `${1.5*customfontsize}px` }}>
            Frequently Asked Questions (FAQs)
          </Typography>
          <Typography variant="h4" component="h2" sx={{ mb: 3 ,fontSize: `${1.2*customfontsize}px` }}>
            Start Learning From World-Class Instructors
          </Typography>
          <Typography variant="body2" color="inherit" component="h2" sx={{fontSize: `${customfontsize}px` }}>
            At Musa Institute for Academic and Skills Development, we provide comprehensive
            education and training in scientific disciplines. Explore how our
            programs can help you achieve your academic and professional goals.
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: 1,
            overflow: "hidden",
            boxShadow: 1,
            textAlign: "start",
          }}
        >
          {faqs.map((faq, index) => ( <AnimatedAccordion
         
         customfontsize={customfontsize}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                    detailsText={faq.answer}
                    summaryText={faq.question}
                    key={`panel${index}-header`}
                  />
            
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FaqSection;
